import React from 'react';

import './ShoppableVideoPageSkeleton.scss';

export const ShoppableVideoPageSkeleton: React.FC = () => (
  <div className="ShoppableVideoPageSkeleton" aria-hidden="true">
    <div className="ShoppableVideoPageSkeleton__theatre">
      <div className="ShoppableVideoPageSkeleton__stage" />
      <div className="ShoppableVideoPageSkeleton__panel" />
    </div>
    <div className="ShoppableVideoPageSkeleton__filmstrip" />
  </div>
);
